var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 224V408C576 412.422 572.406 416 568 416H384C379.594 416 376 412.422 376 408S379.594 400 384 400H548.688L320 171.312L197.656 293.656C196.094 295.219 194.047 296 192 296S187.906 295.219 186.344 293.656L2.344 109.656C0.781 108.094 0 106.047 0 104C0 99.43 3.737 96 8 96C10.047 96 12.094 96.781 13.656 98.344L192 276.688L314.344 154.344C315.906 152.781 317.953 152 320 152S324.094 152.781 325.656 154.344L560 388.688V224C560 219.578 563.594 216 568 216S576 219.578 576 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendDown);
export default __webpack_public_path__ + "static/media/arrow-trend-down.c73097a080e90a79081f7fb44602acf4.svg";
export { ForwardRef as ReactComponent };